import axios from "axios";
import classNames from "classnames";
import React, { useState, FormEvent, useEffect } from "react";
import Aside from "../../components/Aside/Aside";
import { Profile } from "../../types";

import Notification from "../../components/Alert/notification";
import { Navigate } from "react-router-dom";

interface DocumentsProps {}

const DocumentsPage: React.FC<DocumentsProps> = () => {
  const [fileSelected, setFileSelected] = React.useState<File>();
  const [fileUploadSave, setFileUploadSave] = React.useState(true);

  const [profile, setProfile] = useState<Profile>();
  //const [errors, setErrors] = useState(false);
  const [notification, setNotification] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    try {
      axios.get("/v1/profile/info").then((res) => setProfile(res.data));
    } catch (err) {
      console.log(err);
    }
  }, []);

  if (profile?.tariffName === "Стартовый Ямал") return <Navigate to="/inet/activate" />;

  const getDoc = async (event: FormEvent) => {
    event.preventDefault();

    try {
      axios({
        url: "v1/services/document",
        data: { user_id: `${profile?.id}` },
        method: "POST",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "договор_об_оказании_услуг.pdf");
        document.body.appendChild(link);
        link.click();
        setIsDisabled(true);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageChange = function (e: React.ChangeEvent<HTMLInputElement>) {
    const fileList = e.target.files;

    if (!fileList) return;

    setFileSelected(fileList[0]);
  };

  const uploadFile = () => {
    if (fileSelected) {
      const formData = new FormData();
      formData.append("file", fileSelected, fileSelected.name);
      axios
        .post("v1/services/document/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            setFileUploadSave(false);
            setNotification(true);
            setTimeout(() => {
              setNotification(false);
            }, 5000);
          }
        });
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside isJurical={profile?.isJuridical} />
      <div style={{ width: "100%" }}>
        <main data-v-dde546dc="" className="el-main">
          <div data-v-0c054ff4="" data-v-dde546dc="" className="profile">
            <h1 data-v-0c054ff4="">Договор</h1>
            <div data-v-0c054ff4="">
              <div
                data-v-0c054ff4=""
                className="profile__cards gutters el-row el-row--flex"
              >
                {profile?.isJuridical === 0 ? (
                  <>
                    <div
                      data-v-0c054ff4=""
                      className="el-col el-col-24 el-col-sm-12 el-col-md-8"
                    >
                      <div
                        data-v-0c054ff4=""
                        className={classNames(
                          !isDisabled
                            ? "el-card py16 is-always-shadow card--warning"
                            : "el-card py16 is-always-shadow card--success"
                        )}
                      >
                        <div className="el-card__header">
                          <div data-v-0c054ff4="">
                            <i
                              data-v-0c054ff4=""
                              aria-hidden="true"
                              className="fa fa-download card__icon mt-1"
                            ></i>
                            <div
                              data-v-0c054ff4=""
                              className="flex align-center justify-between"
                            >
                              <small data-v-0c054ff4="">Договор абонента</small>
                            </div>
                            <h3 data-v-0c054ff4="" className="editor-content">
                              Скачать договор об оказании услуг связи
                            </h3>
                          </div>
                        </div>

                        <div className="el-card__body align-center justify-center flex mt-3">
                          <div
                            data-v-0c054ff4=""
                            className="flex  align-center "
                          >
                            {!isDisabled ? (
                              <button
                                type="button"
                                className="el-button el-button--warning el-button--small is-plain"
                                onClick={getDoc}
                              >
                                <span>
                                  <small>Скачать</small>
                                </span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="el-button el-button--success el-button--small is-plain is-disabled"
                                onClick={getDoc}
                              >
                                <span>
                                  <small>Договор успешно скачан</small>
                                </span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                {fileUploadSave ? (
                  <div
                    data-v-0c054ff4=""
                    className="el-col el-col-24 el-col-sm-12 el-col-md-8"
                  >
                    <div
                      data-v-0c054ff4=""
                      className="el-card py16 is-always-shadow card--warning"
                    >
                      <div className="el-card__header">
                        <div data-v-0c054ff4="">
                          <i
                            data-v-0c054ff4=""
                            aria-hidden="true"
                            className="fas fa-upload card__icon card__icon--small mt-1"
                          ></i>
                          <div
                            data-v-0c054ff4=""
                            className="flex align-center justify-between"
                          >
                            <small data-v-0c054ff4="">Загрузить договор</small>
                          </div>
                          <h3 data-v-0c054ff4="" className="editor-content">
                            Загрузить копию подписанного договора, последней
                            страницы.
                          </h3>
                        </div>
                        <div className="mt-2">
                          <input
                            type="file"
                            name="file"
                            onChange={handleImageChange}
                            className="foo el-button"
                          />
                        </div>
                      </div>
                      <div className="el-card__body align-center justify-center flex">
                        <div data-v-0c054ff4="" className="flex align-center">
                          <button
                            type="button"
                            className="el-button el-button--warning el-button--small is-plain"
                            onClick={uploadFile}
                          >
                            <span>
                              <small>Загрузить</small>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </main>
      </div>
      {notification ? (
        <Notification message={"Договор успешно загружен"} />
      ) : null}
    </div>
  );
};

export default DocumentsPage;
